export enum ComponentTheme {
  Danger = "danger",
  Warning = "warning",
  Hazard = "hazard",
  Confirmation = "confirmation",
  Info = "info",
  Neutral = "neutral"
}
